import { BehaviorSubject, distinctUntilChanged, ReplaySubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAppSettings } from 'src/app/core/contracts/core.types';

export const settings$ = new ReplaySubject<IAppSettings>(1);
export const languageChanged$ = settings$.pipe(
  map(settings => settings?.language),
  distinctUntilChanged()
);
export const backButton$ = new Subject<void>();
export const loading$ = new BehaviorSubject<boolean>(false);
